/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */
import { Sophistication } from '../../classes/sophistication.js';
var sophistication = new Sophistication({
  /**
   * @description Input JSS styles.
   * @param {*} params - Component props.
   * @returns {Object<string,*>} Style.
   */
  input: function input() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref = params.customColors || {},
        _ref$validColor = _ref.validColor,
        validColor = _ref$validColor === void 0 ? '#94ff36' : _ref$validColor,
        _ref$invalidColor = _ref.invalidColor,
        invalidColor = _ref$invalidColor === void 0 ? '#e83b35' : _ref$invalidColor,
        _ref$warningColor = _ref.warningColor,
        warningColor = _ref$warningColor === void 0 ? '#e8e639' : _ref$warningColor,
        _ref$highlightColor = _ref.highlightColor,
        highlightColor = _ref$highlightColor === void 0 ? null : _ref$highlightColor;

    var borderColor = null;
    var color = null;

    switch (params.status) {
      case 'valid':
        borderColor = [[validColor], '!important'];
        break;

      case 'invalid':
        borderColor = [[invalidColor], '!important'];
        break;

      case 'warning':
        color = warningColor;
        borderColor = warningColor;
        break;

      case 'highlight':
        color = highlightColor;
        borderColor = highlightColor;
        break;

      default:
        break;
    }

    return {
      color: color,
      borderColor: borderColor
    };
  }
});
export { sophistication };